function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useCallback } from "react";
import PropTypes from "prop-types";
import Collapse from "@churchofjesuschrist/eden-collapse";
import { spacing8, spacing16, spacing32 } from "@churchofjesuschrist/eden-style-constants";
import { Text3, Text5 } from "@churchofjesuschrist/eden-text";
import { useMediaQuery } from "@churchofjesuschrist/eden-media-query";
import styled from "styled-components";
const Inner = styled(Text3).withConfig({
  componentId: "sc-33udnh-0"
})(["padding:0 ", " ", ";"], spacing8, spacing32);
const SmallInner = styled(Text5).withConfig({
  componentId: "sc-33udnh-1"
})(["padding:0 ", " ", ";"], spacing16, spacing16);

const Body = ({
  open,
  children,
  printUnsafe,
  minHeight,
  small,
  ...props
}) => {
  const [matches] = useMediaQuery(useCallback(() => {}, []), "print", false);
  return matches && !printUnsafe ? small ? /*#__PURE__*/React.createElement(SmallInner, null, children) : /*#__PURE__*/React.createElement(Inner, null, children) : /*#__PURE__*/React.createElement(Collapse, _extends({}, props, {
    expand: open,
    minHeight: minHeight,
    "aria-hidden": !open
  }), small ? /*#__PURE__*/React.createElement(SmallInner, null, children) : /*#__PURE__*/React.createElement(Inner, null, children));
};

Body.propTypes = {
  /** Contents rendered inside the drawer body */
  children: PropTypes.node.isRequired,

  /** Whether drawer body is open */
  open: PropTypes.bool,

  /** The minimum height (in pixels) of the body content when collapsed */
  minHeight: PropTypes.string,

  /** Whether drawer body content is visible on print media */
  printUnsafe: PropTypes.bool,

  /** Enable small variant */
  small: PropTypes.bool
};
export default Body;